import { DARK_MODE } from '../../constants';
import * as ActionTypes from '../actionTypes';

// Get initial theme from localStorage or default to DARK_MODE
const getInitialTheme = () => {
  const savedTheme = localStorage.getItem('themeMode');
  return savedTheme || DARK_MODE;
};

export const theme = (
  state = {
    themeMode: getInitialTheme(),
  },
  action,
) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_THEME:
      // Save theme to localStorage when it changes
      localStorage.setItem('themeMode', action.themeMode);
      return {
        ...state,
        themeMode: action.themeMode
      };
    default:
      return state;
  }
};
